const API_URL = process.env.REACT_APP_BACKEND_URL || ''

export async function portalRequest(endpoint, options = {}) {
  const token = localStorage.getItem('portal_token')
  
  const headers = {
    'X-Environment': 'production',
    ...(token && { 'Authorization': `Bearer ${token}` }),
    ...options.headers
  }

  // Don't set Content-Type for FormData (browser sets boundary automatically)
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json'
  }

  const res = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers
  })

  if (!res.ok) {
    const error = await res.json().catch(() => ({ detail: 'Request failed' }))
    throw new Error(error.detail || 'Request failed')
  }

  // Handle 204 No Content
  if (res.status === 204) return null
  
  return res.json()
}

export const portalFetcher = (url) => portalRequest(url)
